<ion-menu
  contentId="main-content"
  side="end"
  type="overlay"
  #mobileMenu
  mode="md"
>
  <ion-header>
    <ion-toolbar>
      <ion-title></ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    @if (navigationService.isAuthenticated()) {
      <!-- Main Dashboard Section -->
      <div class="menu-section">
        <ion-item
          button
          (click)="navigateAndClose('/dashboard')"
          [class.active]="navigationService.isRouteActive('/dashboard')"
        >
          <ion-icon name="apps" slot="start"></ion-icon>
          <ion-label>Dashboard</ion-label>
        </ion-item>
      </div>

      <!-- SAYP Section -->
      @if (navigationService.canViewSayp()) {
        <div class="menu-section">
          <div class="section-header">
            <ion-label>Save As You Pay</ion-label>
          </div>
          @for (route of navigationService.saypRoutes(); track route.path) {
            <ion-item
              button
              (click)="navigateAndClose(route.path)"
              [class.active]="navigationService.isRouteActive(route.path)"
            >
              <ion-icon [name]="route.icon" slot="start"></ion-icon>
              <ion-label>{{ route.label }}</ion-label>
            </ion-item>
          }
        </div>
      }

      <!-- Auth Section -->
      <div class="menu-section">
        <ion-item button (click)="signOutAndClose()">
          <ion-icon name="log-out-outline" slot="start"></ion-icon>
          <ion-label>Sign Out</ion-label>
        </ion-item>
      </div>
    } @else {
      <ion-item button (click)="signInAndClose()">
        <ion-icon name="log-in-outline" slot="start"></ion-icon>
        <ion-label>Sign In</ion-label>
      </ion-item>
    }
  </ion-content>
</ion-menu>
